import { DOP_CONFIG } from './config/dopConfig';
import { STEP_COMPONENTS } from './steps';
import Step1Standard from './steps/Step1Standard';
import { useState } from "react";
import {saveDopWizzrd, fetchPanelWizzardDop, updateDopWizzard} from "../../../api/paneliDop";
import {useEffect} from "react";
import {useParams} from "react-router-dom";
import notifyToast from "../../../components/Toast/Toast";
import {useNavigate} from 'react-router-dom'
import {getKvalitetMaterijalaDropdown} from "../../../api";


const DopWizardDetails = () => {

    const [stepIndex, setStepIndex] = useState(0);
    const [loading, setLoading] = useState(false); // loading existing DOP
    const [saving, setSaving] = useState(false);   // saving DOP
    const navigate = useNavigate()
    // const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (!id) return;

        const loadData = async () => {
            try {
                setLoading(true);

                const data = await fetchPanelWizzardDop(Number(id));

                // 🔥 IMPORTANT: map backend → frontend
                setFormData({
                    ...data,
                    privremeniDop: data.privremeni_dop === 1
                });

            } catch (err) {
                console.error(err);
                alert('Greška kod učitavanja DOP-a');
            } finally {
                setLoading(false);
            }
        };

        loadData();

    }, [id]);

    const [formData, setFormData] = useState({
        standard: '',
        zaglavlje: {},
        reakcijaNaVatru: {},
        otpornostNaVatru: {},
        materijal: {},
        karakteristike: {},
        debljine: [],
        // optional fields
        izolacija: '',
        materijal13165: '',
        privremeniDop: false,
        brojNaloga: '',
        stavka: ''
    });

    const selectedStandard = DOP_CONFIG.standards.find(
        (s) => s.value === formData.standard
    );

    const steps = selectedStandard?.steps || [];

    const CurrentStepComponent =
        stepIndex === 0
            ? Step1Standard
            : STEP_COMPONENTS[steps[stepIndex - 1]];

    const isFirstStep = stepIndex === 0;
    const isLastStep = stepIndex === steps.length;

    // =========================
    // SUBMIT FUNCTION
    // =========================
    const handleSubmit = async () => {
        try {
            setSaving(true);

            const payload = {
                ...formData,
            };

            let response;

            if (id) {

                response = await updateDopWizzard(
                    Number(id),
                    payload
                );

                console.log(
                    'UPDATE RESPONSE:',
                    response
                );

                notifyToast(
                    true,
                    'DOP uspješno ažuriran'
                );

            } else {

                response = await saveDopWizzrd(
                    payload
                );

                console.log(
                    'CREATE RESPONSE:',
                    response
                );

                notifyToast(
                    true,
                    'DOP uspješno sačuvan'
                );

            }

            setTimeout(() => {
                navigate(-1);
            }, 1500);

        } catch (error: any) {

            console.error(
                'DOP SAVE ERROR:',
                error
            );

            notifyToast(
                false,
                error?.response?.data?.message ||
                error?.message ||
                'Greška prilikom spremanja'
            );

        } finally {

            setSaving(false);

        }
    };

    return (
        <div className="d-flex justify-content-center">

            <div className="w-100" style={{ maxWidth: '900px' }}>

                <div className="card shadow-sm">
                    <div className="card-body p-5">

                        {/* HEADER */}
                        <div className="mb-6 text-center">
                            <h2 className="fw-bold">Kreiranje DOP-a</h2>
                            <div className="text-muted">
                                Korak {stepIndex + 1} / {steps.length + 1}
                            </div>
                        </div>

                        {/* STEP CONTENT */}
                        <div className="mb-10">
                            <CurrentStepComponent
                                formData={formData}
                                setFormData={setFormData}
                            />
                        </div>

                        <div className='separator mt-3 mb-3'></div>

                        {/* ACTIONS */}
                        <div className="d-flex justify-content-between align-items-center">

                            {/* BACK */}
                            <button
                                className="btn btn-light"
                                disabled={isFirstStep || loading}
                                onClick={() => setStepIndex((prev) => prev - 1)}
                            >
                                ← Nazad
                            </button>

                            {/* NEXT / SUBMIT */}
                            <button
                                className="btn btn-primary"
                                disabled={
                                    saving ||
                                    (isFirstStep && !formData.standard)
                                }
                                onClick={() => {

                                    const zaglavlje: any = formData.zaglavlje || {};
                                    const materijal: any = formData.materijal || {};

                                    // Validation for Step2Zaglavlje
                                    if (stepIndex === 1) {

                                        if (!zaglavlje.vrstaProizvoda) {
                                            notifyToast(
                                                false,
                                                'Molimo odaberite vrstu proizvoda.'
                                            );
                                            return;
                                        }

                                        if (
                                            formData.standard === 'EN_14509_2014'
                                        ) {

                                            if (!materijal.liceKvalitetId)
                                             {
                                                notifyToast(
                                                    false,
                                                    'Molimo odaberite kvalitet materijala gornjeg lima.'
                                                );
                                                return;
                                            }

                                            if (!materijal.nalicjeKvalitetId){
                                                notifyToast(
                                                    false,
                                                    'Molimo odaberite kvalitet materijala donjeg lima.'
                                                );
                                                return;
                                            }
                                        }

                                        if (
                                            formData.standard === 'EN_13165_2017' &&
                                            (
                                                !materijal.liceKvalitet ||
                                                materijal.liceKvalitet.trim() === ''
                                            )
                                        ) {
                                            notifyToast(
                                                false,
                                                'Molimo odaberite kvalitet materijala.'
                                            );
                                            return;
                                        }
                                    }

                                    if (isLastStep) {
                                        handleSubmit();
                                    } else {
                                        setStepIndex((prev) => prev + 1);
                                    }
                                }}
                            >
                                {saving
                                    ? 'Spremanje...'
                                    : isLastStep
                                        ? 'Završi'
                                        : 'Dalje →'}
                            </button>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default DopWizardDetails;